;(function () {
    window.addEventListener('load', () => {
        if (
            !document.querySelector('.template-productbundle-product-infinite ')
        ) {
            return
        }

        setTimeout(() => {
            const cartForm = document.querySelector('form#add-to-cart')
            const simpleBundle = cartForm?.querySelector(
                '#simple-bundles-io-options'
            )
            const selects = simpleBundle?.querySelectorAll('select')
            if (selects?.length === 0) {
                return
            }

            let radioButtonsWrapper =
                '<div class="simple-bundle-options-radio">'
            selects.forEach((selectBox, index) => {
                const label = document.querySelector(
                    `label[for="${selectBox.id}"]`
                )
                let selectOptions = Array.from(
                    selectBox.querySelectorAll('option:not([disabled])')
                )
                let radioButtonsHTML = `<h4 class="mb-2">${label.innerHTML}</h4>`
                const marginBottom = index === selects.length - 1 ? '0' : '2rem'
                radioButtonsHTML += `<div class="radio-selector flex flex-wrap items-center" style="margin-bottom: ${marginBottom}">`

                selectOptions.forEach((option, index) => {
                    let selected = false
                    if (option.selected) {
                        selected = true
                    }

                    radioButtonsHTML += `<div class="radio-selector__option flex ${selected ? 'active' : ''}" style="gap: 1rem;">`
                    radioButtonsHTML += `<input id="${option.value}" name="${selectBox.name}" ${selected ? 'checked' : ''} type="radio" value="${option.value}" style="margin: 0;">`
                    radioButtonsHTML += `<label for="${selectBox.name}" style="margin: 0;"><span>${option.value}</span></label>`
                    radioButtonsHTML += `</div>`
                })

                radioButtonsWrapper += radioButtonsHTML
                radioButtonsWrapper += '</div>'
            })
            radioButtonsWrapper += '</div>'
            simpleBundle.insertAdjacentHTML('afterend', radioButtonsWrapper)
            simpleBundle.remove()

            const radioSelectors = document.querySelectorAll('.radio-selector')
            radioSelectors.forEach((selector) => {
                const options = selector.querySelectorAll(
                    '.radio-selector__option'
                )
                options.forEach((option) => {
                    option.addEventListener('click', (e) => {
                        removeActive(options)
                        const currentInput = option.querySelector('input')
                        currentInput.checked = true
                        option.classList.add('active')
                    })
                })
            })
        }, 1000)

        function removeActive(options) {
            options.forEach((option) => {
                option.classList.remove('active')
            })
        }
    })
})()
